import { getContentPage } from '@/content/pages'
import { resolvePageContent } from '@/content/markdown'
import ContentPage from '@/components/content/ContentPage.vue'
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default function createContentPageView(slug) {
    return {
        name: `ContentPage_${slug}`,
        components: {
            ContentPage,
        },
        data() {
            return {
                loading: false,
                page: getContentPage(slug),
            };
        },
        computed: {
            ...GlobalComputed,
        },
        watch: {
            loading(loading) {
                this.setLinearLoading(loading);
            },
        },
        methods: {
            ...GlobalMethods,
            loadRemote() {
                const local = getContentPage(slug);
                if (!local || !local.apiPath || this.loading) {
                    this.page = local;
                    return;
                }
                this.loading = true;
                this.$store.dispatch('fastGetAction', { url: local.apiPath }).then((response) => {
                    this.page = resolvePageContent(local, response.data);
                    this.loading = false;
                }).catch(() => {
                    this.page = local;
                    this.loading = false;
                });
            },
        },
        mounted() {
            this.loadRemote();
        },
    };
}
